import "./App.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import { Login } from "./pages/login/Login";
import { ForgotPassword } from "./pages/forgot-password/ForgotPassword";
import { ChangePassword } from "./pages/change-password/ChangePassword";
import { ResetPassword } from "./pages/reset-password/ResetPassword";
import Header from "./components/header/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import CommonComponent from "./pages/common/CommonComponent";
import { ContactUs } from "./pages/contact-us/contact-us";
// import Sidebar from "./components/sidebar/Sidebar";
// import UserManagement from "./pages/user-management/UserManagement";
// import NewsManagement from "./pages/news-management/NewsManagement";
// import ProfileSetting from "./pages/profile-setting/ProfileSetting";
// import EventManagement from "./pages/event-management/EventManagement";



function App() {
  useSelector((state) => state.roleReducer);
const { isLogin } = useSelector((state) => state.roleReducer);

  return (
    <div className="App">
      
      {isLogin && <Header /> }
      <Routes>
        
        <Route path="/" element={ isLogin ? <CommonComponent  /> : <Login /> }/>
        <Route path="/contact-us" element={ isLogin ? <CommonComponent  /> : <ContactUs /> }/>

        {/* User Routes  */}
        <Route path="/user-management" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/user-management/profile" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/user-management/addUser" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/user-management/editUser" element={isLogin ?<CommonComponent/> : <Login/>} />

          {/* Role Routes  */}
          <Route path="/role-management" element={isLogin ?<CommonComponent/> : <Login/>} />

           {/* InApp Purhcase Routes  */}
           <Route path="/membership-management" element={isLogin ?<CommonComponent/> : <Login/>} />


        {/* Event Routes  */}
        <Route path="/event-management" element={<CommonComponent />} />
        <Route path="/event-management/AddEvent" element={<CommonComponent />} />
        <Route path="/event-management/EventDetails" element={<CommonComponent />} />
        <Route path="/event-management/EditEvent" element={<CommonComponent />} />

        {/* News Routes  */}
        <Route path="/news-management" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/news-management/AddNews" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/news-management/NewsDetails" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/news-management/EditNews" element={isLogin ?<CommonComponent/> : <Login/>} />


        {/* Profile Routes  */}
        <Route path="/profile-setting" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/profile-setting/AddProfile" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/profile-setting/ChangePassword" element={<CommonComponent />} />
        <Route path="/profile-setting/EditProfile" element={isLogin ?<CommonComponent/> : <Login/>} />

        {/* specialities Routes  */}
        <Route path="/specialities" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/specialities/AddSpecialities" element={isLogin ?<CommonComponent/> : <Login/>} />
        {/* <Route path="/specialities/DetailsSpecialities" element={<CommonComponent />} /> */}
        <Route path="/specialities/ViewSpecialities" element={isLogin ?<CommonComponent/> : <Login/>} />


           {/* VoiceType Routes  */}
           <Route path="/voicetype" element={isLogin ?<CommonComponent/> : <Login/>} />
        {/* <Route path="/specialities/AddSpecialities" element={isLogin ?<CommonComponent/> : <Login/>} /> */}
        {/* <Route path="/specialities/DetailsSpecialities" element={<CommonComponent />} /> */}
        {/* <Route path="/specialities/ViewSpecialities" element={isLogin ?<CommonComponent/> : <Login/>} /> */}


           {/* voiceLanguage Routes  */}
           <Route path="/voicelanguage" element={isLogin ?<CommonComponent/> : <Login/>} />
        {/* <Route path="/specialities/AddSpecialities" element={isLogin ?<CommonComponent/> : <Login/>} /> */}
        {/* <Route path="/specialities/DetailsSpecialities" element={<CommonComponent />} /> */}
        {/* <Route path="/specialities/ViewSpecialities" element={isLogin ?<CommonComponent/> : <Login/>} /> */}


           {/* connectivity Routes  */}
           <Route path="/connectivity" element={isLogin ?<CommonComponent/> : <Login/>} />
        {/* <Route path="/specialities/AddSpecialities" element={isLogin ?<CommonComponent/> : <Login/>} /> */}
        {/* <Route path="/specialities/DetailsSpecialities" element={<CommonComponent />} /> */}
        {/* <Route path="/specialities/ViewSpecialities" element={isLogin ?<CommonComponent/> : <Login/>} /> */}


        {/* Sponsor Routes  */}
        <Route path="/Sponsor" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/Sponsor/AddSponsor" element={isLogin ?<CommonComponent/> : <Login/>} />
        {/* <Route path="/specialities/DetailsSpecialities" element={<CommonComponent />} /> */}
        <Route path="/Sponsor/ViewSponsor" element={isLogin ?<CommonComponent/> : <Login/>} />


        {/* badges Routes  */}
        <Route path="/badges" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/badges/AddBadges" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/badges/ViewBadges" element={<CommonComponent />} />
        <Route path="/badges/EditBadges" element={isLogin ?<CommonComponent/> : <Login/>} />
        {/* <Route path="/badges/EditBadges" element={isLogin ?<CommonComponent/> : <Login/>} /> */}

        {/* manage-request Routes  */}
        {/* <Route path="/profile-setting" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/profile-setting/AddProfile" element={isLogin ?<CommonComponent/> : <Login/>} />
        <Route path="/profile-setting/ChangePassword" element={<CommonComponent />} />
        <Route path="/profile-setting/EditProfile" element={isLogin ?<CommonComponent/> : <Login/>} /> */}


        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
      </Routes>
    </div>
  );
}

export default App;
